import ProductInfo from './ProductInfo';

export default ProductInfo;


// WEBPACK FOOTER //
// ./src/components/ProductInfo/index.tsx